import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MedReviewRoutingModule } from './med-review-routing.module';
import { MedReviewComponent } from './med-review.component';
import { MedReviewListComponent } from './components/med-review-list/med-review-list.component';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PortletModule } from '../../partials/content/general/portlet/portlet.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducer } from './reducers/med-review.reducer';
import { MedReviewEffects } from './effects/med-review.effects';
import { MatSortModule } from '@angular/material/sort';
import { MedReviewBoardComponent } from './components/med-review-board/med-review-board.component';
import { MedReviewBoardHeaderComponent } from './components/med-review-board-header/med-review-board-header.component';
import { FlexModule } from '@angular/flex-layout';
import { InlineSVGModule } from 'ng-inline-svg';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MedReviewBoardBodyComponent } from './components/med-review-board-body/med-review-board-body.component';
import { PvReviewComponent } from './components/pv-review/pv-review.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { MatSelectModule } from '@angular/material/select';
import { MedReviewCardComponent } from './components/med-review-card/med-review-card.component';
import { PinchZoomModule } from 'ngx-pinch-zoom';
import { Pv1DialogComponent } from './components/pv1-dialog/pv1-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { Pv1MoreDetailsDialogComponent } from './components/pv1-more-details-dialog/pv1-more-details-dialog.component';
import { SelectErrorDialogComponent } from './components/select-error-dialog/select-error-dialog.component';
import { MatRadioModule } from '@angular/material/radio';
import { ReactiveFormsModule } from '@angular/forms';
import { PartialsModule } from '../../partials/partials.module';
import { MedReviewFilterComponent } from './components/med-review-filter/med-review-filter.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { OfficesService } from '../../../core/management';
import { MedicationHistoryComponent } from './components/medication-history/medication-history.component';
import { GeneralInputDialogComponent } from '../../partials/content/crud';
import { MedReviewAddStandardComponent } from './components/med-review-add-standard/med-review-add-standard.component';
import { DrpComponent } from './drp/drp.component';
import { DrpDashboardCardComponent } from './drp/drp-dashboard-card/drp-dashboard-card.component';
import { DrpDashboardBodyComponent } from './drp/drp-dashboard-body/drp-dashboard-body.component';
import { DrpDashboardComponent } from './drp/drp-dashboard/drp-dashboard.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { InterventionHistoryListComponent } from './drp/intervention-history-list/intervetion-history-list.component';
import { InterventionHistoryEffects } from './effects/intervention-history.effects';
import { PendProblemComponent } from './drp/pend-problem/pend-problem.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ManageProblemComponent } from './drp/manage-problem/manage-problem.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { MatIconModule } from '@angular/material/icon';
import { interventionHistoryReducer } from './reducers/intervention-history.reducer';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { CustomDrpComponent } from './drp/custom-drp/custom-drp.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { CoreModule } from '../../../core/core.module';
import { MedReviewConfigComponent } from './components/med-review-config/med-review-config.component';
import { BambooHealthDataComponent } from './components/bamboo-health-data/bamboo-health-data.component';
import { SharedModule } from '../../../shared/shared.module';

@NgModule({
  providers: [OfficesService],
  imports: [
    CommonModule,
    MedReviewRoutingModule,
    MatTableModule,
    TranslateModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    PortletModule,
    StoreModule.forFeature('medReview', reducer),
    EffectsModule.forFeature([MedReviewEffects]),
    StoreModule.forFeature('interventionHistory', interventionHistoryReducer),
    EffectsModule.forFeature([InterventionHistoryEffects]),
    MatSortModule,
    FlexModule,
    InlineSVGModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatTooltipModule,
    NgbDropdownModule,
    MatSelectModule,
    PinchZoomModule,
    MatDialogModule,
    MatRadioModule,
    ReactiveFormsModule,
    PartialsModule,
    MatDatepickerModule,
    MatInputModule,
    DragDropModule,
    MatButtonToggleModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatIconModule,
    PerfectScrollbarModule,
    NgxPermissionsModule,
    CoreModule,
    SharedModule,
  ],
  entryComponents: [
    Pv1DialogComponent,
    Pv1MoreDetailsDialogComponent,
    SelectErrorDialogComponent,
    MedicationHistoryComponent,
    GeneralInputDialogComponent,
    DrpComponent,
    InterventionHistoryListComponent,
    PendProblemComponent,
    ManageProblemComponent,
    CustomDrpComponent,
    MedReviewBoardBodyComponent,
    MedReviewAddStandardComponent,
    MedReviewConfigComponent,
    BambooHealthDataComponent,
  ],
  declarations: [
    MedReviewComponent,
    MedReviewListComponent,
    MedReviewBoardComponent,
    MedReviewBoardHeaderComponent,
    MedReviewBoardBodyComponent,
    PvReviewComponent,
    MedReviewCardComponent,
    Pv1DialogComponent,
    Pv1MoreDetailsDialogComponent,
    SelectErrorDialogComponent,
    MedReviewFilterComponent,
    MedicationHistoryComponent,
    DrpComponent,
    DrpDashboardCardComponent,
    DrpDashboardBodyComponent,
    DrpDashboardComponent,
    InterventionHistoryListComponent,
    PendProblemComponent,
    ManageProblemComponent,
    CustomDrpComponent,
    MedReviewAddStandardComponent,
    MedicationHistoryComponent,
    MedReviewConfigComponent,
    BambooHealthDataComponent,
  ],
  exports: [MedReviewBoardComponent, MedReviewListComponent],
})
export class MedReviewModule {}
